var map = {
	"./be-fr.json": [
		2794,
		"src_assets_i18n_be-fr_json"
	],
	"./be-nl.json": [
		6887,
		"src_assets_i18n_be-nl_json"
	],
	"./de.json": [
		3634,
		"src_assets_i18n_de_json"
	],
	"./en.json": [
		502,
		"src_assets_i18n_en_json"
	],
	"./es.json": [
		4268,
		"src_assets_i18n_es_json"
	],
	"./fr.json": [
		1463,
		"src_assets_i18n_fr_json"
	],
	"./gr.json": [
		48,
		"src_assets_i18n_gr_json"
	],
	"./ir.json": [
		3177,
		"src_assets_i18n_ir_json"
	],
	"./it.json": [
		2766,
		"src_assets_i18n_it_json"
	],
	"./nl.json": [
		164,
		"src_assets_i18n_nl_json"
	],
	"./pt.json": [
		5733,
		"src_assets_i18n_pt_json"
	],
	"./ru.json": [
		8879,
		"src_assets_i18n_ru_json"
	],
	"./sa.json": [
		3843,
		"src_assets_i18n_sa_json"
	],
	"./si.json": [
		2709,
		"src_assets_i18n_si_json"
	],
	"./us.json": [
		6059,
		"src_assets_i18n_us_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6297;
module.exports = webpackAsyncContext;